import React from 'react';

function LeftArrow() {
    return (
        <svg width="5" height="8" viewBox="0 0 5 8" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.82679 7.8419C4.94226 7.7365 5 7.6117 5 7.46751C5 7.3236 4.94226 7.19895 4.82679 7.09354L1.44342 4.00527L4.83834 0.906456C4.94611 0.808081 5 0.685112 5 0.537549C5 0.389987 4.94226 0.263505 4.82679 0.158103C4.71132 0.0527009 4.5746 0 4.41663 0C4.25897 0 4.1224 0.0527009 4.00693 0.158103L0.12702 3.71014C0.0808311 3.75231 0.0480366 3.79798 0.0286369 3.84717C0.00954533 3.89635 -4.76837e-07 3.94906 -4.76837e-07 4.00527C-4.76837e-07 4.06148 0.00954533 4.11419 0.0286369 4.16337C0.0480366 4.21256 0.0808311 4.25823 0.12702 4.3004L4.01848 7.85244C4.12625 7.95081 4.25897 8 4.41663 8C4.5746 8 4.71132 7.9473 4.82679 7.8419Z" fill="#868691"/>
        </svg>

    );
}

export default LeftArrow;